import styled, {css, SimpleInterpolation} from 'styled-components';
import Media from "../../assets/styles/media";

export const TableWrapper = styled.div`
  max-height: 600px;
  width: 100%;
  overflow: auto;
`;

export const DynamicTable = styled.table`
  width: 100%;
  overflow: hidden;
  th {
    background-color: #0082bd;
    color: white;
  }
`;

export const TableHead = styled.th`
  background-color: #0082bd;
  color: white;
  font-size: 18pt;
  
  ${(props): SimpleInterpolation =>
    props.sub &&
    css`
      position: sticky;
      top: 0;
  `}
`;

export const TableRow = styled.tr`

`;

export const TableCell = styled.td`
  background-color: #d3e7f0;
  text-align: center;
  ${(props): SimpleInterpolation =>
  props.odd &&
  css`
    background-color: #ffffff;
  `}

  ${(props): SimpleInterpolation =>
  props.bold &&
  css`
      font-weight: bold;
    `
} 
`;

export const TableMonthHead = styled.th`
  background-color: #ffffff;
  position: sticky;
  top: 0;
`;